// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__r7W6R","plus":"styles_plus__yFrvz","key":"styles_key__yXn6U"};